import VideosTable from './VideosTable';

export default VideosTable;